import { render, staticRenderFns } from "./paystatus.vue?vue&type=template&id=31d61258&scoped=true&"
import script from "./paystatus.vue?vue&type=script&lang=js&"
export * from "./paystatus.vue?vue&type=script&lang=js&"
import style0 from "./paystatus.vue?vue&type=style&index=0&id=31d61258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d61258",
  null
  
)

export default component.exports